import { Container } from 'react-bootstrap';
import SupportMobile from './SupportMobile';

const SupportMobileDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <h4>Support Mobile</h4>
        <SupportMobile />
      </Container>
    </Container>
  );
};

export default SupportMobileDemo;
